import React from 'react';
import styled from 'styled-components';
import TreeSelect from 'antd/lib/tree-select';

const style = { width: 328 };

export const StyledTreeSelect = styled(props => <TreeSelect {...props} style={style} />)``;
